var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('img',{style:({ width: _vm.imgWidth ? `${_vm.imgWidth}px` : '100%' }),attrs:{"src":require("../../assets/images/empty-state.svg"),"alt":"Empty state"}}),_c('h4',{staticClass:"text-center mt-2"},[_vm._v(_vm._s(_vm.text ? _vm.text : "No data available"))])])
}
var staticRenderFns = []

export { render, staticRenderFns }